import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
  "promotion": {
    "title": "Swift promo code",
    "description": "Keep up on our events and get the best deals.",
    "input_placeholder": "Have a promo code?",
    "extended_success": {
      "title": "Trial extended successfully",
      "description": "You have extended your free trial period on the <strong>{plan_name}</strong> until <strong>{time}</strong>."
    },
    "free_warning": {
      "title": "Code redeemed successfully",
      "description": "You’ve successfully claimed a <strong>Premium</strong> 7-day free trial",
      "option_one": "If you agree to continue, your subscription will be upgraded immediately from Free to Premium plan",
      "option_two": "You can downgrade, or cancel your subscription at any time"
    },
    "buttons": {
      "redeem_now": "Redeem now",
      "keep_free": "Keep using Free",
      "upgrade_plan": "Upgrade to Premium"
    },
    "errors": {
      "code_invalid": "Invalid code, please try again"
    }
  }
})